import { styledPolymorphic } from '@qred/components-library';

export const StandardStepNavbarWrapper = styledPolymorphic<'div', {}>()(
  (_styled) => _styled`
  width: 100%;
    ${({ theme }) =>
      `${theme.fn.largerThan('tablet')} {
      width: 50em;
    }`}

`
);
